<template>
	<div class="LocationFilter">
		<CountrySearch />
		<div class="ContinentHeader" role="button" @click="toggleContinent">
			<span class="LocationHeader">Narrow by Continent</span>
			<i
				class="Icon"
				:class="`lnr-chevron-${isContinentOpen ? 'up' : 'down'}`"
				aria-hidden="true"
			></i>
		</div>
		<div
			class="ContinentList"
			:class="{ 'isOpen': isContinentOpen }"
			:aria-hidden="!isContinentOpen"
		>
			<RadioSelectItem
				v-for="continent in continentItems"
				:key="continent.value"
				:item="continent"
				name="continent-filter"
				:highlightSelectedText="true"
				@selectionChange="(state) => handleSelect(continent.value, state === SelectListItemStateType.SELECTED)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import CountrySearch from './CountrySearch.vue';
import RadioSelectItem from '@components/RadioSelectItem/RadioSelectItem.vue';
import { SelectListItemStateType } from '@app/enums/SelectListItemStateType';
import { provideLocationFilterContext } from '@composables/useLocationFilterContext';

const {
	continentItems,
	isContinentOpen,
	toggleContinent,
	handleSelect
} = provideLocationFilterContext();
</script>

<style scoped lang="scss">
.LocationFilter {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1rem;
	@include AddBorderBeforeElement(1, 2);	// required for outline not to be cut off

	.LocationHeader {
		color: $Grey-900;
		@include TextStyle(UiMediumBold);
	}

	.CountrySearch {
		border-bottom: 1px solid $Grey-300;
	}

	.ContinentHeader {
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		user-select: none;

		.Icon {
			font-size: 1rem;
			color: $Grey-900;
		}
	}

	.ContinentList {
		display: flex;
		flex-direction: column;
		padding: 2px 2px 0 0;	// required for outline not to be cut off
		max-height: 0;
		overflow: hidden;
		pointer-events: none;
		transition: max-height 0.3s ease;

		&.isOpen {
			max-height: 18rem;
			pointer-events: auto;
		}
	}
}
</style>
